import { PcRestartResponse } from '@acorn-portal/shared/src/services/subscriptionAPI';
import { IOptions } from '@acorn-portal/shared/src/components/inputs/select';
import { IChangeUsageOrMileageForm } from './get-usage-cover-details';
import getClosestMileage from '@acorn-portal/shared/src/utils/getClosestMileage';

export const getMileageUsageInitialValues = (
	quoteData: PcRestartResponse | undefined,
	annualMileageOptions: IOptions[],
): IChangeUsageOrMileageForm => ({
	vehicleUse: quoteData?.quoteDetails.riskData.vehicleDetails.vehicleUse || '',
	levelOfCover: quoteData?.quoteDetails.riskData.coverDetails.levelOfCover || '',
	annualMileage: getClosestMileage(annualMileageOptions, quoteData?.quoteDetails.riskData.vehicleDetails.annualMileage),
	businessMileage: getClosestMileage(
		annualMileageOptions,
		quoteData?.quoteDetails.riskData.vehicleDetails.businessMileage !== undefined
			? quoteData.quoteDetails.riskData.vehicleDetails.businessMileage
			: undefined,
	),
});
